export const LoginResult = {
  Success: 'Success',
  InvalidCredentials: 'InvalidCredentials',
  NetworkError: 'NetworkError',
} as const;

export type LoginResult = typeof LoginResult[keyof typeof LoginResult];
